export class MsgToUser {

  message: string;
  color: string; //for demo should be enum

  constructor(message: string, color: string) {
    this.message = message
    this.color = color
  }

}
